"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = exports.Counter = exports.Accordion = exports.StyledListItemIcon = exports.StyledListItem = exports.StyledListItemContent = exports.LeftSidebar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.LeftSidebar = styled_components_1.default.div `
  width: 285px;
  height: 100%;
  overflow: auto;
  border-right: 1px solid ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'outline')};
  transform: translateZ(0);
`;
exports.StyledListItemContent = (0, styled_components_1.default)(wl_ui_kit_1.ListItemContent) `
  justify-content: space-between;
  margin-left: 0;
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
  ${({ $level2 }) => ($level2 ? wl_ui_kit_1.Body2Styles : wl_ui_kit_1.Body1Styles)};

  &&& {
    color: ${({ $selected }) => $selected && (0, wl_ui_kit_1.getColor)('quaternary')};
  }
`;
exports.StyledListItem = (0, styled_components_1.default)(wl_ui_kit_1.ListItem) `
  outline: 0;

  & > div {
    padding: ${(0, wl_ui_kit_1.getSizeBy)(2.5)} ${({ $isFlat }) => (0, wl_ui_kit_1.getSizeBy)($isFlat ? 4 : 2)};
  }
`;
exports.StyledListItemIcon = (0, styled_components_1.default)(wl_ui_kit_1.ListItemIcon) `
  margin-right: ${(0, wl_ui_kit_1.getSizeBy)(2)};
`;
exports.Accordion = (0, styled_components_1.default)(wl_ui_kit_1.StyledSvgAccordion) `
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;
exports.Counter = styled_components_1.default.div `
  ${wl_ui_kit_1.Subtitle1Styles};
  padding: ${(0, wl_ui_kit_1.getSizeBy)(0.5)} ${(0, wl_ui_kit_1.getSizeBy)(1.5)};
  color: ${(0, wl_ui_kit_1.getColor)('onSurface')};
  background-color: ${(0, wl_ui_kit_1.getColor)('onBackground')};
  border-radius: ${(0, wl_ui_kit_1.getSizeBy)(20)};
`;
exports.Divider = styled_components_1.default.div `
  height: 1px;
  margin-top: ${(0, wl_ui_kit_1.getSizeBy)(3)};
  margin-bottom: ${(0, wl_ui_kit_1.getSizeBy)(4)};
  background-color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'outline')};
`;
